import { VirtualTableHeadCell } from "../../virtualized-table/types";
import { SelectColumnFilter } from '../../virtualized-table/components/filter';
import DownloadFile from "../download-file";

export const rtdsFilesHeadCells: VirtualTableHeadCell[] = [
    {
        accessor: 'generationType',
        Header: 'Gen Type',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'vimsFileName',
        Header: 'VIMS Config File Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'vimsSha1',
        Header: 'VIMS SHA Value',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'rtdsSha1',
        Header: 'RTDS SHA Value',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },

    {
        accessor: 'subscriptionName',
        Header: 'Base Subscription Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'updatedTS',
        Header: 'Last Updated Date ',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'updatedBy',
        Header: 'Last Updated By ',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'downloadIcon',
        Header: 'Download',
        component: DownloadFile,
    },
];

export const rtdsFilesHeadCellsSortableAccessors = {
    generationType: true,
    vimsFileName: true,
    vimsSha1: true,
    updatedTS: true,
    subscriptionName: true,
    rtdsSha1: true,
    updatedBy: true
};

export const vimsConfigHeadCells: VirtualTableHeadCell[] = [
     {
        accessor: 'generationType',
        Header: 'Gen Type',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
        width: 90,

    },
    {
        accessor: 'fileName',
        Header: 'File Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
        width: 140
    },
    {
        accessor: 'id',
        Header: 'SHA Value',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
        width: 300,
    },
];

export const vimsConfigSortableAccessors = {
    fileName: true,
    date: true,
    partNumber: true,
    id: true,
    generationType: true,
};
